import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import styled, { ThemeProvider } from "styled-components"
import { clearFix } from "polished"
import { translate } from "react-i18next"
import BackToTalentToolboxLink from "./navigation/BackToTalentToolboxLink"
import { Hyperlink } from "../themed-html-components"
import { ENVIRONMENT, ROUTES } from "../../constants"
import { media } from "../../utils/style-utils"
import LanguagePicker from "../LanguagePicker"

const FooterContainer = styled.footer`
  text-align: left;
  z-index: 100;
  ${media.tablet`display: none;`};
`
const FooterLinks = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  ${clearFix()};
`

const FooterLinkLeft = styled.li`
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  float: left;
`

const FooterLinkRight = FooterLinkLeft.extend`
  float: right;
`

const BackToTtLink = styled(BackToTalentToolboxLink)`
  color: ${props => props.theme.primaryColor} !important;
  &:hover {
    color: ${props => props.theme.primaryColorHover} !important;
  }
`

function Footer({ children, t, userDetails }) {
  return userDetails.client.subdomain ? (
    <ThemeProvider theme={userDetails.theme}>
      <FooterContainer className="footer d-print-none">
        <FooterLinks>
          <FooterLinkLeft>
            <Hyperlink href={ENVIRONMENT.getTalentToolboxUrl(userDetails.client.subdomain)}>
              <i className="mdi mdi-arrow-left" />
            </Hyperlink>
            <BackToTtLink theme={userDetails.theme} />
          </FooterLinkLeft>

          <FooterLinkRight>
            <Hyperlink
              href={ENVIRONMENT.getTalentToolboxUrl(
                userDetails.client.subdomain,
                ROUTES.talentToolboxUrls.contactUs
              )}
              text={t("Footer.Links.ContactUs")}
              target="_blank"
            />
          </FooterLinkRight>

          <FooterLinkRight>
            <Hyperlink
              href={ENVIRONMENT.getTalentToolboxUrl(
                userDetails.client.subdomain,
                ROUTES.talentToolboxUrls.cookies
              )}
              text={t("Footer.Links.Cookies")}
              target="_blank"
            />
          </FooterLinkRight>

          <FooterLinkRight>
            <Hyperlink
              href={ENVIRONMENT.getTalentToolboxUrl(
                userDetails.client.subdomain,
                ROUTES.talentToolboxUrls.privacy
              )}
              text={t("Footer.Links.PrivacyPolicy")}
              target="_blank"
            />
          </FooterLinkRight>

          <FooterLinkRight>
            <Hyperlink
              href={ENVIRONMENT.getTalentToolboxUrl(
                userDetails.client.subdomain,
                ROUTES.talentToolboxUrls.terms
              )}
              text={t("Footer.Links.TermsAndConditions")}
              target="_blank"
            />
          </FooterLinkRight>

          <FooterLinkRight>
            <LanguagePicker />
          </FooterLinkRight>
        </FooterLinks>
        {children}
      </FooterContainer>
    </ThemeProvider>
  ) : null
}

function mapStateToProps(state) {
  return {
    userDetails: state.userDetail,
  }
}

Footer.propTypes = {
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
  userDetails: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
    culture: PropTypes.string,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    client: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subdomain: PropTypes.string,
    }),
  }).isRequired,
}

Footer.defaultProps = {
  children: null,
}

export default compose(translate(), connect(mapStateToProps))(Footer)



// WEBPACK FOOTER //
// ./src/components/layout/Footer.jsx